import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as alertify from "alertifyjs";
import { Router } from "@angular/router";
import { Constant } from "src/app/Shared/Constant";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiServiceService } from 'src/app/Services/api-service.service';

@Component({
    selector: 'app-forgot',
    templateUrl: './forgot.component.html',
    styleUrls: ['./forgot.component.css']
})
export class ForgotComponent implements OnInit {
    forgotForm: any = FormGroup;

    constructor(
        private apiService: ApiServiceService,
        private router: Router,
        private fb: FormBuilder,
    ) { }


    ngOnInit(): void {
        this.forgotForm = this.initializeForm();
        
    }

    initializeForm() {
        return (this.forgotForm = this.fb.group({
            email: ["", [Validators.required, Validators.email]],
        }));
    }

    resetPassword() {
        // check if form is valid
        if (this.forgotForm.invalid) {
            alertify.set('notifier', 'position', 'top-center');
            alertify.error("Please provide valid email address");
            return;
        }

        const url = "/auth/password-reset-link?email=" + this.forgotForm.controls['email'].value;

        // call api to reset password
        this.apiService.loginPost_(url, {}).subscribe({
            next: (response: any) => {
                var message = response.message;
                if (message.includes("not found")) {
                    alertify.set('notifier', 'position', 'top-center');
                    alertify.error(response.message);
                } else {
                    alertify.set('notifier', 'position', 'top-center');
                    alertify.success("Password reset link sent to your email! Check it immediately.", 5);
                    this.router.navigate(['/auth/login']);                    
                }
            },
            error: (error: any) => {
                alertify.set('notifier', 'position', 'top-center');
                alertify.error(error.message || Constant.ERROR_OCCURED);
            }
        });
        
    }

}
